(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_carousel-navigation"] && !Shopify.designMode) return;
  try {
    class CarouselNav extends HTMLElement {
    connectedCallback() {
      this.#mount();
      this.prevBtn = this.querySelector('.carousel-nav__btn--prev');
      this.nextBtn = this.querySelector('.carousel-nav__btn--next');

      if (this.dataset.bound === 'true') return;

      this.prevBtn?.addEventListener('click', () => this.#navigate('previous'));
      this.nextBtn?.addEventListener('click', () => this.#navigate('next'));
      this.dataset.bound = 'true';
    }

    #mount() {
      if (this.dataset.navPosition !== 'overlay' || this.dataset.mounted === 'true') return;

      const section = this.closest('.shopify-section');
      const slideshowContainer = section?.querySelector('slideshow-component > slideshow-container');
      if (!slideshowContainer) {
        requestAnimationFrame(() => this.#mount());
        return;
      }

      slideshowContainer.appendChild(this);
      this.dataset.mounted = 'true';
    }

    #navigate(direction) {
      const section = this.closest('.shopify-section');
      const slideshow = section?.querySelector('slideshow-component');
      if (!slideshow) return;
      if (direction === 'previous') {
        slideshow.previous?.();
      } else {
        slideshow.next?.();
      }
    }
  }

  if (!customElements.get('carousel-nav')) {
    customElements.define('carousel-nav', CarouselNav);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["swatches"] && !Shopify.designMode) return;
  try {
    if (!window.__swatchTooltipInit) {
  window.__swatchTooltipInit = true;

  const tooltip = document.createElement('div');
  tooltip.className = 'swatch-hover-tooltip';
  document.body.appendChild(tooltip);

  const isHoverCapable = window.matchMedia('(hover: hover) and (min-width: 750px)').matches;

  if (isHoverCapable) {
    document.addEventListener('pointerover', (event) => {
      const label = event.target.closest('.variant-option__button-label[data-tooltip-label]');
      if (!label) return;

      tooltip.textContent = label.getAttribute('data-tooltip-label');
      const rect = label.getBoundingClientRect();
      tooltip.style.left = `${rect.left + rect.width / 2}px`;
      tooltip.style.top = `${rect.bottom + 4}px`;
      tooltip.style.opacity = '1';
    });

    document.addEventListener('pointerout', (event) => {
      const label = event.target.closest('.variant-option__button-label[data-tooltip-label]');
      if (!label) return;
      tooltip.style.opacity = '0';
    });
  }
}
  } catch(e) { console.error(e); }
})();

})();
